<template>
  <v-col cols="12" class="pb-0 pl-0">
    <span class="txtLabel"> {{ title }}</span>
    <v-row class="pb-0">
      <v-col cols="4" class="pb-0">
        <input-documento
          v-model="model.documentoFederal"
          :label="cpf ? 'CPF': 'CNPJ'"
          :cpf="cpf"
          :cnpj="!cpf"
          @change="emitEventDocumento"
          required
          :rules="validaDocumento.length > 0 ? rules : []"
          :disabled="isEdit || editPessoa"/>
      </v-col>
      <v-col cols="8" class="pb-0">
        <input-text
          v-model="model.nome"
          :label="cpf ? 'Nome completo' : 'Razão social' "
          required
          allow-special-chars
          :disabled="isEdit || disable"
        />
      </v-col>
    </v-row>
    <!-- // variação PF -->
    <v-row v-if="cpf && !basic" class="pb-0">
      <v-col cols="4" class="pb-0">
        <input-text
          label="RG/CNH/RNE"
          v-model="model.pf.rg"
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-datetext
          v-model="model.pf.rgData"
          label="Data de emissão"
          :disabled="disable"/>
      </v-col>
      <v-col cols="2">
        <input-text
          label="Órgão expedidor"
          v-model="model.pf.rgOrgao"
          :disabled="disable"/>
      </v-col>
      <v-col cols="3">
        <input-datetext
          v-model="model.pf.dtNasc"
          label="Data nascimento"
          required
          :disabled="disable"/>
      </v-col>
      <v-col cols="4">
        <input-text
          v-model="model.pf.nomeMae"
          label="Nome da mãe"
          required
          allow-special-chars
          :disabled="disable"/>
      </v-col>
      <v-col cols="4">
        <input-text
          v-model="model.pf.nomePai"
          label="Nome do pai"
          allow-special-chars
          :disabled="disable"/>
      </v-col>
      <v-col cols="4">
        <input-select
          v-model="model.pf.estadoCivil"
          label="Estado civil"
          :options="$aux.EstadoCivil"
          :disabled="disable"/>
      </v-col>
      <v-col cols="4" v-if="model.pf.estadoCivil === 2">
        <input-documento
          v-model="model.pf.cpfConjuge"
          label="CPF do cônjuge"
          :rules="() => validacaoConjuge(model.documentoFederal, model.pf.cpfConjuge)"
          cpf
          :disabled="disable"/>
      </v-col>
      <v-col cols="8" v-if="model.pf.estadoCivil === 2">
        <input-text
          v-model="model.pf.nomeConjuge"
          label="Nome completo do cônjuge"
          allow-special-chars
          :disabled="disable"/>
      </v-col>
    </v-row>
    <v-row v-if="cpf">
      <v-col cols="3">
        <input-number
          v-if="!disable || missingRenda"
          format="currency"
          v-model="model.pf.renda"
          label="Renda"
          required
        />
        <input-number
          v-else
          format="currency"
          :value="$api.UI.Format.Decimal(model.pf.renda)"
          label="Renda"
          disabled
          required
        />
      </v-col>
      <v-col cols="3">
        <input-text
          v-model="model.pf.profissao"
          label="Profissão"
          required
          :disabled="disable && !missingProfissao"
        />
      </v-col>
      <v-col cols="3">
        <input-autocomplete
          v-model="model.pf.nacionalidade"
          :items="$aux.Nacionalidades"
          label="Nacionalidade"
          append-icon="mdi-magnify"
          :disabled="disable && !missingNacionalidade"
          required
        ></input-autocomplete>
      </v-col>
      <v-col cols="3">
        <input-select
          v-model="model.pf.sexo"
          label="Gênero"
          :options="$aux.Sexo"
          :disabled="disable && !missingGenero"
          required
        />
      </v-col>
    </v-row>
    <!-- // variação PJ -->
    <v-row v-if="!cpf && tipoEmpresa">
      <v-col cols="4">
          <input-select
            label="Tipo de empresa"
            :options="$aux.TipoEmpresaOnboarding"
            v-model="model.tipoEmpresa"
            required
            :disabled="disable"/>
        </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    basic: {
      type: Boolean,
      default: false,
    },
    tipoEmpresa: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Dados gerais'
    },
    tipoPessoa: {
      type: Number,
      default: 1
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editPessoa: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    validaDocumento: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      rules: [
        value => value !== this.validaDocumento || 'Documento federal não pode ser igual a do titular da conta',
      ],
      missingRenda: false,
      missingProfissao: false,
      missingNacionalidade: false,
      missingGenero: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    cpf () {
      return this.tipoPessoa === this.$aux.TipoPessoaEnum.PF
    }
  },
  methods: {
    emitEventDocumento () {
      this.$emit('handleEventDocumento', this.model.documentoFederal)
    },
    validacaoConjuge (CPFCorrentista, CPFConjuge) {
      if (CPFConjuge) {
        return [CPFCorrentista !== CPFConjuge || 'O CPF do cônjuge não pode ser igual o correntista']
      }
    },
  },
  mounted () {
    const th = this
    th.missingRenda = th.model.pf && typeof this.model.pf === 'object' && th.model.pf.renda === null
    th.missingNacionalidade = th.model.pf && typeof th.model.pf === 'object' && th.model.pf.nacionalidade === null
    th.missingProfissao = th.model.pf && typeof th.model.pf === 'object' && th.model.pf.profissao === null
    th.missingGenero = th.model.pf && typeof th.model.pf === 'object' && th.model.pf.sexo === null
  }
}
</script>
<style scoped>
  .txtLabel{
    font-weight: 600;
    font-size: 16px;
    margin:0 12px;
  }

  ::v-deep .v-input__append-inner .v-icon {
    transform: none !important;
  }
</style>
